import { toUrlT } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import AddParticipantsToGroupFormStore from '.';
import { callApi } from '../../../../../../../Appy';
import { handleError } from '../../../../../../../ErrorActionableReaction';
import { warnAndNotify } from '../../../../../../../Honeybadger';
import { findLinkT } from '../../../../../../../LinkyLinky';
import ReactionComponent, { RCProps } from '../../../../../../../ReactionComponent';
import { Link } from '../../../../../../../Resource/Types';
import { bulkGroupMembershipsResourceDecoder } from '../../../../../Participants/BulkActions/AddParticipantsToGroup/UserGroupMembershipsForm/Store/Decoders';
import {
  AddParticipantsToGroupFormError,
  AddParticipantsToGroupFormState,
  Submitting,
} from './Types';

interface Props extends RCProps<AddParticipantsToGroupFormStore> {}

const handleGroupError =
  (store: AddParticipantsToGroupFormStore) => (error: AddParticipantsToGroupFormError) => {
    switch (error.kind) {
      case 'missing-link-error':
      case 'invalid-url-error':
        store.error('We are unable to process your request at this time');
        warnAndNotify('GroupReactions', error.kind, error);
        break;
      default:
        console.warn('[AddParticipantsToGroupFormError] unkown error.kind:', error);
        handleError(store, error);
    }
  };

const processLink =
  (id: string) =>
  (link: Link): Task<AddParticipantsToGroupFormError, Link> =>
    toUrlT(link.href.replace('{group_id}', `${id}`)).map(
      (url): Link => ({ ...link, href: url.href }),
    );

const bulkGroupMembershipsEncoder = (state: Submitting) => ({
  user_group_memberships: {
    user_ids: state.participants.map((successfulParticipants) => successfulParticipants.id),
    user_group_id: state.group.value,
  },
});

class AddParticipantsToGroupReactions extends ReactionComponent<
  AddParticipantsToGroupFormStore,
  AddParticipantsToGroupFormState,
  Props
> {
  tester = () => this.props.store.state;
  effect = (state: AddParticipantsToGroupFormState) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'submitting':
        Task.succeed<AddParticipantsToGroupFormError, ReadonlyArray<Link>>(
          state.importedParticipantsResource.links,
        )
          .andThen(findLinkT('create'))
          .andThen(processLink(state.group.value))
          .andThen(callApi(bulkGroupMembershipsResourceDecoder, bulkGroupMembershipsEncoder(state)))
          .fork(handleGroupError(store), store.success);
        break;
      case 'ready':
      case 'ready-to-submit':
      case 'success':
        break;
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default AddParticipantsToGroupReactions;
